<template>
  <v-container fluid class="contact-container">
    <v-layout row wrap class="pa-5 px40">
      <v-flex xs12 sm12 md6 lg6 class="white--text" :class="$vuetify.breakpoint.mdOnly ? 'px40' : 'px80'">
        <h3 class="black--text" style="opacity: 0.5">Contact</h3>
        <h3 class="my-4 hidden-xs-only">Michel Coupert - 
          <span style="font-weight: 300; text-transform: none">Juriste expert</span>
        </h3>
        <h3 class="my-4" v-if="$vuetify.breakpoint.xsOnly">Michel Coupert<br/> 
          <span style="font-weight: 300; text-transform: none">Juriste expert</span>
        </h3>
        <!-- <p class="mb-4" style="font-weight: 500">Espace Créateurs d’Entreprises<br/>de la ville de Saint-Dizier</p> -->
        <p class="mb-4">8, avenue Raoul LAURENT<br/>52100 SAINT-DIZIER</p>
        <p>06 64 05 95 70<br/>michelcoupert@gmail.com</p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 class="pt-3 pr-5">
        <google-map />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GoogleMap from "@/components/GoogleMap";

export default {
  name: 'contact-section',
  components: {
    GoogleMap
  }
}
</script>

<style>
.contact-container {
  background-color: #A8201A;
}
.smOnly .contact-container .flex,
.xsOnly .contact-container .flex {
  padding: 0px !important;
  text-align: center;
}
/* Style for small devices */
.smOnly .contact-container .layout {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.smOnly .contact-container h3 {
  margin: 16px 0 !important;
}
.smOnly .contact-container p {
  margin-bottom: 16px !important;
}
.smOnly .contact-container p:last-child {
  margin-bottom: 40px !important;
}
/* Style for extra small devices */
.xsOnly .contact-container .layout {
  padding: 16px !important;
}
.xsOnly .contact-container h3 {
  margin: 16px 0 !important;
  font-size: 14px;
}
.xsOnly .contact-container p {
  margin-bottom: 12px !important;
  font-size: 12px;
}
.xsOnly .contact-container p:last-child {
  margin-bottom: 40px !important;
}
</style>
